import { useEffect, useRef } from 'react';
import {
  useAppDispatch,
  useJackpotControllerGetActiveJackpotsQuery,
  useJackpotControllerGetReservesQuery,
  useJackpotControllerGetDrawPlatinumJackpotTimeInUtcQuery,
} from '@app/store';
import {
  setActiveJackpots,
  setReservesJackpots,
  setDrawJackpot,
  setPlatinumNextDrawMs,
} from '@pages/JackpotPage/store/jackpotSlice';

export const useJackpotGlobal = () => {
  const dispatch = useAppDispatch();
  const prevActiveRef = useRef<string[]>([]);

  // активные джекпоты
  const { data: activeJackpotsData } = useJackpotControllerGetActiveJackpotsQuery(
    undefined,
    {
      pollingInterval: 10000,
      refetchOnMountOrArgChange: true,
    },
  );

  // резервы джекпотов
  const { data: reservesData } = useJackpotControllerGetReservesQuery(undefined, {
    pollingInterval: 10000,
    refetchOnMountOrArgChange: true,
  });

  // время платинового джекпота
  const { data: platinumTimeData } =
    useJackpotControllerGetDrawPlatinumJackpotTimeInUtcQuery(undefined, {
      pollingInterval: 60000,
      refetchOnMountOrArgChange: true,
    });

  useEffect(() => {
    if (reservesData) dispatch(setReservesJackpots(reservesData));
  }, [dispatch, reservesData]);

  useEffect(() => {
    const prevIds = prevActiveRef.current;
    const current = activeJackpotsData ?? [];
    const currentIds = current.map((j) => j.id);

    const drawJackpots =
      prevIds.length === 0 ? [] : prevIds.filter((id) => !currentIds.includes(id));

    dispatch(setDrawJackpot(drawJackpots));

    if (drawJackpots.length > 0) {
      setTimeout(() => {
        dispatch(setActiveJackpots(activeJackpotsData));
      }, 1100);
    } else {
      dispatch(setActiveJackpots(activeJackpotsData));
    }

    prevActiveRef.current = currentIds;
  }, [activeJackpotsData, dispatch]);

  useEffect(() => {
    if (platinumTimeData?.msBeforeNextDraw !== undefined) {
      dispatch(setPlatinumNextDrawMs(platinumTimeData.msBeforeNextDraw));
    }
  }, [dispatch, platinumTimeData]);
};
